import React from "react";
import {
  DisputeSettlment,
  MixingBearingCost,
  MusicVideoClausesOptions,
  RemixClausesOptions,
} from "shared/components/AllDropdownOptions";
import {
  CustomCalendar,
  CustomCheckbox,
  CustomDropDown,
  CustomInput,
  CustomTextArea,
} from "shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import formValidation from "utils/validations";

const MusicVideo = ({ data, setData }) => {
  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleCheckboxChange = (name, isChecked) => {
    setData((prev) => {
      const currentClauses = [...(prev.clauses || [])];

      if (isChecked) {
        if (!currentClauses.some((item) => item.name === name)) {
          currentClauses.push({
            name,
            value:
              name === "governmentlaw"
                ? prev.governmentlaw?.law || ""
                : prev.termination?.day || "",
          });
        }

        return {
          ...prev,
          clauses: currentClauses,
          ...(name === "governmentlaw" &&
            !prev.governmentlaw && {
            governmentlaw: { law: "" },
          }),
          ...(name === "termination" &&
            !prev.remedies && {
            termination: { day: "" },
          }),
        };
      } else {
        const index = currentClauses.findIndex((item) => item.name === name);
        if (index !== -1) currentClauses.splice(index, 1);
        return { ...prev, clauses: currentClauses };
      }
    });
  };
  return (
    <>
      {data?.agreementType === "Music Video" && <></>}
      <div className="w-6">
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          label="Name of Agreement"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-center">
          <CustomInput
            name="fullLegalName"
            data={data}
            col={5}
            onChange={handleChange}
            label="Artist Full Legal Name"
          />
          <div className="col text-center">p/k/a</div>
          <CustomInput
            data={data}
            label="Artist Name"
            col={5}
            name="name"
            onChange={handleChange}
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <label className="text-gray-500 mb-0" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              col={12}
              className="w-full "
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <CustomInput
            name="director"
            data={data}
            label="Director or Production Company"
            col={6}
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full "
            rows={5}
            cols={30}
            data={data}
            label="Bussiness Address"
            name="bussinessAddress"
            onChange={handleChange}
          />
          <label htmlFor="" className="col-12 font-bold text-xl">Scope Of work</label>
          <CustomInput
            data={data}
            label="Music Release Title"
            col={6}
            name="realeaseTitle"
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full "
            rows={5}
            cols={30}
            data={data}
            label="Scope of Music Video Production"
            name="scopeProduction"
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            label="Fee for the Music Video"
            col={6}
            name="musicVideoFee"
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            label="Payment Schedule"
            col={6}
            name="paymentSchedule"
            onChange={handleChange}
          />
          <div className="col-12">
            <label htmlFor="" className="font-bold text-xl">Payment terms for Addittional Cost</label>
            <p className="color-grey mt-2 text-sm">Payment terms for Additional Expenses to exlain what is "Additional Expenses</p>
          </div>
          <CustomInput
            data={data}
            label="Payment terms for Additional Cost"
            col={12}
            name="paymentTerms"
            onChange={handleChange}
            ignoreLabel
            extraClassName="p-0 px-2"
          />
          <label htmlFor="" className="col-12 text-xl font-bold">Delivery</label>
          <CustomCalendar
            label="Delivery Date"
            col={6}
            name="deliveryDate"
            value={data?.deliveryDate ? new Date(data.deadline) : null}
            data={data}
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            name="videoFormat"
            col={6}
            onChange={handleChange}
            label="Video Format (Specify)"
          />
          <div className="col-12">
            <h5 className="text-xl font-medium mb-3">Dispute Resolution</h5>
          </div>
          <CustomInput
            data={data}
            name="days"
            col={6}
            onChange={handleChange}
            label="No. of Days"
          />
          <CustomInput
            data={data}
            name="jurisdiction"
            col={6}
            onChange={handleChange}
            label="Jurisdiction"
          />
          <CustomDropDown
            options={DisputeSettlment}
            optionLabel="name"
            data={data}
            col={12}
            name="disputeSettlement"
            onChange={handleChange}
            label="Settled by"
          />
          <CustomInput
            data={data}
            name="producerQuotation"
            col={6}
            onChange={handleChange}
            label="Producer Quatation"
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-2">
              Add any clauses that may be needed for your contract.
            </p>
            <CustomCheckbox label="I accept"
              name="copyright"
              checked={true} />
            <CustomTextArea placeholder="Any other comments"
              className="bg-white w-full" col={6}
              rows={5}
              cols={30}
              ignoreLabel />
            <label htmlFor="">Warranties and Respresentations</label>
            <CustomCheckbox label="I accept"
              name="copyright"
              checked={true} />
            <CustomTextArea placeholder="Any other comments"
              className="bg-white w-full" col={6}
              rows={5}
              cols={30}
              ignoreLabel />
            <label htmlFor="">Schedule and Location</label>
            <CustomCheckbox label="I accept"
              name="copyright"
              checked={true} />
            <CustomTextArea placeholder="Any other comments"
              className="bg-white w-full" col={6}
              rows={5}
              cols={30}
              ignoreLabel />
            <label htmlFor="">Termination</label>
            <CustomInput placeholder="Number of Days" className="bg-white w-full" />
            <label htmlFor="">Government Law</label>
            <CustomCheckbox label="I accept"
              name="copyright"
              checked={true} />
            <CustomTextArea placeholder="Any other comments"
              className="bg-white w-full" col={6}
              rows={5}
              cols={30}
              ignoreLabel />
            <label htmlFor="">Entire Aggrement</label>
            <CustomCheckbox label="I accept"
              name="copyright"
              checked={true} />
              <br />
            <CustomButton label="Generate contract" />
          </div>
        </div>
      </div>
    </>
  );
};

export default MusicVideo;
